import { IImageObjectRef } from '../../../../../modules/API/Images/models/imageObject';
import { buildDeliveryImageRef } from '../../drivers/helpers/imageRef';

/**
 * Адрес фотографий теуды из параметров роута. В режиме создания ('new')
 * и при любом мусоре в URL запроса нет. Delivery_Sub = 0 — валидный номер.
 */
export const buildTeudaImageRef = (
    id: string | undefined,
    subID: string | undefined,
): IImageObjectRef | null => {
    // Number('') === 0, поэтому пустые строки отсекаем явно.
    if (!id || !subID) return null;

    const num = Number(id);
    const sub = Number(subID);
    if (!Number.isInteger(num) || num <= 0 || !Number.isInteger(sub) || sub < 0) return null;

    return buildDeliveryImageRef({ Delivery_Num: num, Delivery_Sub: sub });
};
